import { z } from 'zod';

import { addressValueSchema, hexValueSchema } from './shared';

const originalErrorSchema = z.object({
  data: hexValueSchema,
});

const errorSchema = z.object({
  message: z.string(),
  data: z.object({
    originalError: originalErrorSchema,
  }),
});

const transactionSchema = z.object({
  from: addressValueSchema,
  to: addressValueSchema,
  data: hexValueSchema,
});

export const ethersTransactionErrorSchema = z.object({
  method: z.string(),
  transaction: transactionSchema,
  error: errorSchema,
});

export const viemTransactionErrorSchema = z.object({
  cause: z.object({
    data: z.object({
      errorName: z.string(),
    }),
  }),
});
